module.exports = __webpack_public_path__ + "img/3.4c68c2f8.jpg";